import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../lib/api';

export default function Forgot() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function handleSubmit() {
    setBusy(true);
    try {
      await apiFetch('/api/auth/forgot', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
    } catch (e) { /* vague: ignore */ }
    finally { setBusy(false); setSent(true); }
  }

  return (
    <div className="page-content" style={{ maxWidth: 360, margin: '64px auto', padding: 24 }}>
      <h1>Forgot password</h1>
      {sent ? (
        <p>If that email is registered, a reset link is on its way.</p>
      ) : (
        <>
          <input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
            style={{ display: 'block', width: '100%', margin: '8px 0', padding: 8 }} />
          <button onClick={handleSubmit} disabled={busy} style={{ width: '100%', padding: 10 }}>
            {busy ? 'Sending…' : 'Send reset link'}
          </button>
        </>
      )}
      <p style={{ marginTop: 12 }}><Link to="/login">Back to sign in</Link></p>
    </div>
  );
}
